import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const Edit: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="20" height="20" viewBox="0 0 19 18" {...props}>
    <path d="M15.7942 5.28004C16.0867 4.98754 16.0867 4.50004 15.7942 4.22254L14.0392 2.46754C13.7617 2.17504 13.2742 2.17504 12.9817 2.46754L11.6017 3.84004L14.4142 6.65254M2.51172 12.9375V15.75H5.32422L13.6192 7.44754L10.8067 4.63504L2.51172 12.9375Z" />
  </SvgIcon>
);
